// extracted by mini-css-extract-plugin
module.exports = {"menuBarRoot":"mSWQrjEA","menuItem":"WD0c0RaI","menuItemSearch":"J1iSUld9","styledButton":"sQZY4_FC"};